export default "__VITE_ASSET__UpTL$6Hx__"